<template>
	<div>
		<!-- doc list -->
		<el-dialog title="内容列表" :visible.sync="dialogVisible" width="80%">
			<el-dropdown trigger="click">
				<el-button type="primary" icon="el-icon-setting" size="mini">
					筛选
					<i class="el-icon-arrow-down el-icon--right"></i>
				</el-button>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item v-for="(items, index) in filtrateList" :key="index">
						<el-dropdown trigger="hover" placement="right-start" @command="seleCommand">
							<el-button type="text" icon="el-icon-caret-right" size="mini">{{ items.label }}</el-button>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item
									icon="el-icon-caret-right"
									v-for="(item, key) in items.seconds"
									:key="key"
									:command="{ indexa: index, indexb: key, param: items.paramValue, paramval: item.val }"
									:class="item.checked ? 'color-blue' : ''"
								>
									{{ item.label }}
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			<el-button type="warning" size="mini" icon="el-icon-refresh" @click="getDocList">刷新</el-button>
			<el-table
				ref="docList"
				:data="docList"
				style="width: 100%;margin-bottom: 20px;"
				row-key="did"
				:stripe="true"
				:default-sort="{ prop: 'did', order: 'descending' }"
				@sort-change="sortChange"
				tooltip-effect="dark"
			>
				<el-table-column label="" width="40">
					<template slot-scope="scope">
						<el-radio
							:label="scope.$index"
							@change.native="chooseCurrentDoc(scope.row)"
							style="color: #fff;padding-left: 10px; margin-right: -25px;"
						></el-radio>
					</template>
				</el-table-column>
				<el-table-column prop="did" label="序号" sortable></el-table-column>
				<el-table-column prop="mid" label="所属模型">
					<template slot-scope="scope">
						{{ mlist[scope.row.mid].modelname }}
					</template>
				</el-table-column>
				<el-table-column prop="tid" label="分类名称">
					<template slot-scope="scope">
						{{ mlist[scope.row.mid].modelname }}
					</template>
				</el-table-column>
				<el-table-column prop="title" label="内容标题" show-overflow-tooltip></el-table-column>
			</el-table>
			<div class="block">
				<el-pagination
					@size-change="docSizeChange"
					@current-change="docCurrentChange"
					:current-page="docpage"
					:page-sizes="pageSizes"
					:page-size="docpagesize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="doctotal"
				></el-pagination>
			</div>
		</el-dialog>
		<!-- doc list end -->
	</div>
</template>
<script>
	export default{
		name:'',
		data(){
			return {
				dialogVisible: false,
				docList:[],
				mlist:[],
				tlist:[],
				docpage: 1,
				doctotal: 0,
				docpagesize: 10, //每页显示条数
				pageSizes: [10, 15, 20, 30], //每页显示个数选择器
				doc_mid:'',
				doc_sort_param:'did',
				doc_sort_type:'desc',
				filtrateList: [
					{
						label: '所属模型',
						paramValue: 'mid',
						seconds: [
							{
								val: '',
								label: '全部',
								checked: true
							}
						]
					}
				],
				selectParams:[],
				bindDocTitle:'',
				firstOpen:true
			}
		},
		props:{
			
		},
		mounted(){
			
		},
		methods:{
			show(){
				this.dialogVisible = true;
				if(this.firstOpen){
					this.getDocList('first');
					this.firstOpen = false;
				}
			},
			getDocList(first){
				let separ = [];
				for (let i in this.selectParams) {
					console.log(i, this.selectParams[i]);
					separ.push({ param: i, paramVal: this.selectParams[i] });
				}
				this.$axios({
					url: this.HOST + '/admin.document/getDocumentList',
					method: 'post',
					data: {
						adminid: JSON.parse(this.$store.state.user.userInfo).id,
						token: JSON.parse(this.$store.state.user.userInfo).token,
						thispage:this.docpage,
						pagesize:this.docpagesize,
						sort_param:this.doc_sort_param,
						sort_type:this.doc_sort_type,
						selectParams:separ,
					}
				})
					.then(res => {
						console.log(res.data);
						if (res.data.status == 0) {
							this.$message.error(res.data.msg);
							if (res.data.admin_err == 'userinfo_error') {
								this.exit().then(res => {
									console.log(res);
									if (res.actionStatus == 1) {
										this.$router.push('/login');
									}
								});
							}
						} else {
							this.docList = res.data.data;
							this.doctotal = res.data.total;
							if(first){
								this.mlist = res.data.mlist;
								this.tlist = res.data.tlist;
								for (let i in res.data.mlist) {
									this.filtrateList[0].seconds.push({
										val: res.data.mlist[i].mid,
										label: res.data.mlist[i].modelname
									});
								}
							}
						}
					})
					.catch(err => {});
			},
			//每页分页条数修改
			docSizeChange(val) {
				// console.log(`每页 ${val} 条`);
				this.docpagesize = val;
				this.getDocList();
			},
			//当前页码翻页
			docCurrentChange(val) {
				// console.log(`当前页: ${val}`);
				this.docpage = val;
				this.getDocList();
			},
			//产品列表排序查询
			sortChange({ column, prop, order }) {
				console.log(column, prop, order);
				this.doc_sort_param = prop;
				this.doc_sort_type = order == 'descending' ? 'desc' : 'asc';
				this.getDocList();
			},
			// 选择关联产品did
			chooseCurrentDoc(e) {
				console.log(e);
				this.$emit('confirm',e);
				this.dialogVisible = false;
			},
			//查询条件变动
			seleCommand(command) {
				console.log('sele:', command);
				this.selectParams[command.param] = command.paramval;
				this.filtrateList[command.indexa].seconds.map(item => {
					this.$set(item, 'checked', false);
				});
				this.filtrateList[command.indexa].seconds[command.indexb].checked = true;
				console.log(this.selectParams);
				this.getDocList();
			},
		}
		
	}
</script>
<style>
	
</style>
